<template>
    <main id="mainCtrl">
        <header>
            <div class="header-filters">
                <div class="header-filters__group">
                    <date-range-picker ref="datepicker"
                                       @selected="setPeriodFilter"/>
                </div>
            </div>
            <div class="stat">
                <div class="stat_item">
                    <div class="stat_item__num">
                        {{ data.feedbackRequestsCount }}
                    </div>
                    <div class="stat_item__info">
                        Запросов<br>отправлено
                    </div>
                </div>

                <div class="stat_item">
                    <div class="stat_item__num"
                         :class="{'stat_item__num-red': data.commonReviewsCountDynamic < 0, 'stat_item__num-green' : data.commonReviewsCountDynamic > 0}"
                    >
                        {{ data.commonReviewsCountDynamic > 0 ? '+' : '' }}{{ data.commonReviewsCountDynamic }}
                    </div>
                    <div class="stat_item__info">
                        Динамика<br>отзывов
                    </div>
                </div>

                <div class="stat_item">
                    <div class="stat_item__num"
                         :class="{'stat_item__num-red': data.commonRatingDynamic < 0, 'stat_item__num-green' : data.commonRatingDynamic > 0}"
                    >
                        {{ data.commonRatingDynamic > 0 ? '+' : '' }}{{ data.commonRatingDynamic }}
                    </div>
                    <div class="stat_item__info">Динамика<br>рейтинга</div>
                </div>

                <div class="stat_item">
                    <div class="stat_item__num">{{ data.negativeFeedbackCount }}</div>
                    <div class="stat_item__info">Негатива<br>перехвачено</div>
                </div>

                <div class="stat_item">
                    <div class="stat_item__num">
                        {{ data.commonRating }}
                    </div>
                    <div class="stat_item__info">
                        <div class="stat_item__stars">
                            <i class="star" :class="starClass(0)"/>
                            <i class="star" :class="starClass(1)"/>
                            <i class="star" :class="starClass(2)"/>
                            <i class="star" :class="starClass(3)"/>
                            <i class="star" :class="starClass(4)"/>
                        </div>
                        {{ data.commonReviewsCount }} отзывов
                    </div>
                </div>
            </div>
        </header>

        <table class="feedbackAnalyticsTable" :class="{loading: loading}">
            <tr>
                <th style="min-width: 300px;">
                    Площадки
                </th>
                <th colspan="2">
                    Рейтинг
                </th>
                <th style="min-width: 200px;">
                    Динамика рейтинга
                </th>
                <th colspan="2">
                    Отзывы
                </th>
                <th style="min-width: 200px;">
                    Динамика отзывов
                </th>
            </tr>

            <tr class="dateRow">
                <td>
                    <input disabled>
                </td>
                <td>
                    <input disabled v-model="dateFrom" type="date">
                </td>
                <td>
                    <input disabled v-model="dateTo" type="date">
                </td>
                <td>
                    <input disabled>
                </td>
                <td>
                    <input disabled v-model="dateFrom" type="date">
                </td>
                <td>
                    <input disabled v-model="dateTo" type="date">
                </td>
                <td>
                    <input disabled>
                </td>
            </tr>

            <tr v-if="isDoctuOn">
                <td class="platformName">
                    <svg viewBox="0 0 17 16" width="13" height="13">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.91671 12.4236C11.4606 12.4236 14.3334 9.64247 14.3334 6.21179C14.3334 2.78111 11.4606 0 7.91671 0C4.37286 0 1.5 2.78111 1.5 6.21179C1.5 9.64247 4.37286 12.4236 7.91671 12.4236ZM7.91676 9.58909C9.84352 9.58909 11.4055 8.07702 11.4055 6.21179C11.4055 4.34655 9.84352 2.83448 7.91676 2.83448C5.98999 2.83448 4.42804 4.34655 4.42804 6.21179C4.42804 8.07702 5.98999 9.58909 7.91676 9.58909Z" fill="#13A546"/>
                        <path d="M11.0158 12.2491L13.9048 15.5026C14.4362 16.101 15.368 16.1691 15.9862 15.6547C16.6043 15.1403 16.6746 14.2381 16.1433 13.6397L13.3211 10.4616C12.6962 11.2055 11.9107 11.8178 11.0158 12.2491Z" fill="#13A546"/>
                    </svg>
                    <b>
                        <a :href="doctuUrl" target="_blank">ДОКТУ</a>
                    </b>
                </td>
                <td>
                    {{ data.doctuRatingFrom }}
                </td>
                <td>
                    {{ data.doctuRatingTo }}
                </td>
                <td>
                    {{ data.doctuRatingDynamic }}
                </td>
                <td>
                    {{ data.doctuReviewsCountFrom }}
                </td>
                <td>
                    {{ data.doctuReviewsCountTo }}
                </td>
                <td>
                    {{ data.doctuReviewsCountDynamic }}
                </td>
            </tr>

            <tr v-if="isYandexMapsOn" class="darkRow">
                <td class="platformName">
                    <svg viewBox="0 0 13 15" width="13" height="13">
                        <path d="M6.5 0C3.19 0 0.5 2.69 0.5 6C0.5 7.66 1.17 9.16 2.26 10.24C3.35 11.33 5.9 12.9 6.05 14.55C6.07 14.8 6.25 15 6.5 15C6.75 15 6.93 14.8 6.95 14.55C7.1 12.9 9.66 11.33 10.74 10.24C11.83 9.15 12.5 7.65 12.5 6C12.5 2.69 9.81 0 6.5 0Z" fill="#FF4433"/>
                        <path d="M6.49999 8.10039C7.65999 8.10039 8.59999 7.16039 8.59999 6.00039C8.59999 4.84039 7.65999 3.90039 6.49999 3.90039C5.33999 3.90039 4.39999 4.84039 4.39999 6.00039C4.39999 7.16039 5.33999 8.10039 6.49999 8.10039Z" fill="white"/>
                    </svg>
                    <b>
                        <a :href="yandexUrl ? yandexUrl : 'https://maps.yandex.ru/'" target="_blank">Яндекс Карты</a>
                    </b>
                </td>
                <td>
                    {{ data.yandexRatingFrom }}
                </td>
                <td>
                    {{ data.yandexRatingTo }}
                </td>
                <td>
                    {{ data.yandexRatingDynamic }}
                </td>
                <td>
                    {{ data.yandexReviewsCountFrom }}
                </td>
                <td>
                    {{ data.yandexReviewsCountTo }}
                </td>
                <td>
                    {{ data.yandexReviewsCountDynamic }}
                </td>
            </tr>

            <tr v-if="is2GisOn">
                <td class="platformName">
                    <svg viewBox="0 0 16 15" width="13" height="13">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 15C12.125 15 15.5 11.64 15.5 7.5C15.5 3.36 12.125 0 8 0C3.875 0 0.5 3.36 0.5 7.5C0.5 11.64 3.86 15 8 15Z" fill="#19AA1E"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2.5498C10.475 2.5498 12.155 4.4548 12.155 6.5098C12.155 7.3348 11.975 8.0548 11.555 8.9548C9.095 8.9548 8.645 10.5898 8.54 11.6848L8.465 12.4498H7.535L7.46 11.6848C7.355 10.5898 6.905 8.9548 4.445 8.9548C4.025 8.0548 3.845 7.3348 3.845 6.5098C3.845 4.4548 5.525 2.5498 8 2.5498Z" fill="white"/>
                    </svg>
                    <b>
                        <a :href="twoGisUrl ? twoGisUrl : 'https://2gis.ru/'" target="_blank">2ГИС</a>
                    </b>
                </td>
                <td>
                    {{ data.twoGisRatingFrom }}
                </td>
                <td>
                    {{ data.twoGisRatingTo }}
                </td>
                <td>
                    {{ data.twoGisRatingDynamic }}
                </td>
                <td>
                    {{ data.twoGisReviewsCountFrom }}
                </td>
                <td>
                    {{ data.twoGisReviewsCountTo }}
                </td>
                <td>
                    {{ data.twoGisReviewsCountDynamic }}
                </td>
            </tr>

            <tr v-if="isGoogleOn" class="darkRow">
                <td class="platformName">
                    <svg viewBox="0 0 12 16" height="15" width="15">
                        <path d="M3.30428 11.8531C3.8356 12.4705 4.37673 13.2468 4.65991 13.7157C5.00478 14.3253 5.14777 14.7369 5.40432 15.4741C5.55432 15.8779 5.69732 16.0004 5.99732 16.0004C6.32537 16.0004 6.47537 15.7946 6.59032 15.4741C6.83005 14.7825 7.0151 14.2563 7.30809 13.7548C8.43802 11.7749 10.2801 10.3682 11.3175 8.4404C11.3175 8.4404 12.0002 7.2629 12.0002 5.61388C12.0002 4.07688 11.3273 3.00879 11.3273 3.00879L3.30848 11.8661L3.30428 11.8531Z" fill="#34A853"/>
                        <path d="M0.584493 8.23157C1.23077 9.59924 2.46314 10.798 3.30428 11.8531L7.7622 6.94205C7.7622 6.94205 7.13275 7.70795 5.99581 7.70795C4.7285 7.70795 3.6967 6.77011 3.6967 5.5848C3.6967 4.76941 4.21961 4.2041 4.21961 4.2041C0.939173 4.65739 1.12142 5.39593 0.574679 8.22896L0.584493 8.23157Z" fill="#FBBC04"/>
                        <path d="M7.81824 0.255859C9.30425 0.700027 10.566 1.63656 11.323 3.00423L7.76216 6.95094C7.76216 6.95094 8.28507 6.38303 8.28507 5.57024C8.28507 4.36018 7.18599 3.44709 5.99998 3.44709C4.81398 3.44709 4.23359 4.20387 4.23359 4.20387C4.50696 3.62554 7.33178 0.452544 7.82245 0.257162L7.81824 0.255859Z" fill="#4285F4"/>
                        <path d="M1.39755 1.99289C2.28355 1.01338 3.83685 0 5.98175 0C7.01775 0 7.80422 0.255299 7.80422 0.255299L4.22938 4.20201C3.98826 4.08048 1.63587 2.37845 1.39755 1.98768V1.99289Z" fill="#1A73E8"/>
                        <path d="M0.584493 8.23157C0.584493 8.23157 0 7.15352 0 5.60088C0 4.12901 0.619638 2.83949 1.4019 2.00586L4.23373 4.22019L0.588797 8.23202L0.584493 8.23157Z" fill="#EA4335"/>
                    </svg>
                    <b>
                        <a :href="googleUrl ? googleUrl : 'https://maps.google.ru/'" target="_blank">Google</a>
                    </b>
                </td>
                <td>
                    {{ data.googleRatingFrom }}
                </td>
                <td>
                    {{ data.googleRatingTo }}
                </td>
                <td>
                    {{ data.googleRatingDynamic }}
                </td>
                <td>
                    {{ data.googleReviewsCountFrom }}
                </td>
                <td>
                    {{ data.googleReviewsCountTo }}
                </td>
                <td>
                    {{ data.googleReviewsCountDynamic }}
                </td>
            </tr>
        </table>
    </main>
</template>

<script>
export default {
    props: {
        isYandexMapsOn: {
            type: Boolean,
            required: true,
        },
        is2GisOn: {
            type: Boolean,
            required: true,
        },
        isDoctuOn: {
            type: Boolean,
            required: true,
        },
        isGoogleOn: {
            type: Boolean,
            required: true,
        },
        doctuUrl: {
            type: String,
            required: true,
        },
        yandexUrl: {
            type: String,
            required: true,
        },
        twoGisUrl: {
            type: String,
            required: true,
        },
        googleUrl: {
            type: String,
            required: true,
        },
    },
    data: function () {
        return {
            dateFrom: '',
            dateTo: '',
            data: this.getEmptyData(),
            loading: false,
            getDataRequest: null,
        };
    },
    methods: {
        getEmptyData() {
            return {
                feedbackRequestsCount: 0,
                negativeFeedbackCount: 0,
                commonReviewsCountDynamic: 0,
                commonRatingDynamic: 0,
                commonReviewsCount: 0,
                commonRating: 0,
                doctuReviewsCountFrom: 0,
                doctuReviewsCountTo: 0,
                doctuReviewsCountDynamic: 0,
                doctuRatingFrom: 0,
                doctuRatingTo: 0,
                doctuRatingDynamic: 0,
                yandexReviewsCountFrom: 0,
                yandexReviewsCountTo: 0,
                yandexReviewsCountDynamic: 0,
                yandexRatingFrom: 0,
                yandexRatingTo: 0,
                yandexRatingDynamic: 0,
                twoGisReviewsCountFrom: 0,
                twoGisReviewsCountTo: 0,
                twoGisReviewsCountDynamic: 0,
                twoGisRatingFrom: 0,
                twoGisRatingTo: 0,
                twoGisRatingDynamic: 0,
                googleReviewsCountFrom: 0,
                googleReviewsCountTo: 0,
                googleReviewsCountDynamic: 0,
                googleRatingFrom: 0,
                googleRatingTo: 0,
                googleRatingDynamic: 0,
            };
        },
        setPeriodFilter(data) {
            this.dateFrom = this.$refs.datepicker.start;
            this.dateTo = this.$refs.datepicker.end;

            if (data) {
                this.loading = true;

                if (this.getDataRequest) {
                    this.getDataRequest.cancel();
                }

                this.getDataRequest = this.axios.CancelToken.source();

                this.axios.post('analytics/getData', {
                    dateFrom: this.dateFrom,
                    dateTo: this.dateTo,
                }, {
                    cancelToken: this.getDataRequest.token
                }).then(response => {
                    this.data = response.data;
                    this.loading = false;
                });
            } else {
                this.data = this.getEmptyData();
            }
        },
        starClass(starIndex) {
            if (Number(this.data.commonRating) < (starIndex + 0.25)) {
                return 'star-empty'
            }
            if (Number(this.data.commonRating) >= (starIndex + 0.25) && Number(this.data.commonRating) <= (starIndex + 0.75)) {
                return 'star-half'
            }
            return 'star-full'
        }
    },
    mounted() {
        if (this.$refs.datepicker.placeholder === 'empty') {
            this.$refs.datepicker.placeholder = 'lastThirtyDays';
            this.$refs.datepicker.setPlaceholderDateToInput();
        }
    }
}
</script>

<style lang="scss">
.feedbackAnalyticsTable {
    margin-top: 10px;

    .dateRow td {
        padding: 1px 2px;
        background-color: #ebebeb;
    }

    th {
        padding: 2px;
        text-overflow: ellipsis;
        min-width: 10px;
        text-align: center;
        vertical-align: middle;
        background-color: #ebebeb;
        font-size: 13px;
    }

    td {
        padding: 5px;
        font-size: 13px;

        &:not(.platformName) {
            text-align: center;
        }
    }

    input {
        font-size: 13px;
        color: rgb(51, 51, 51) !important;
        font-weight: 700;
        background-color: #ebebeb !important;
        text-align: center;
    }

    img {
        margin-right: 2px;
    }

    .darkRow {
        background-color: #ebebeb;
    }
}

.stat {
    font-family: "Open Sans", sans-serif;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    gap: 8px;
    text-box-trim: trim-both;
}
.stat_item {
    box-sizing: border-box;
    border: 1px solid #ddd9ea;
    align-items: center;
    justify-content: center;
    display: flex;
    gap: 8px;
    border-radius: 4px;
    padding: 0 8px;
    flex: 0 0 230px;
    height: 66px;
}
.stat_item__num {
    font-weight: 600;
    font-size: 48px;
    line-height: 1.2;
}
.stat_item__num-red {
    color: #dc4a39;
}
.stat_item__num-green {
    color: #13a546;
}
.stat_item__info {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: 16px;
    line-height: 1.4;
}
.stat_item__stars {
    display: flex;
    align-items: center;
    gap: 6px;
    position: relative;
    bottom: -6px;
}
.stat_item__stars svg {
    display: block;
    line-height: 1;
    width: 15px;
    height: 14px;
}
.stat_item__stars i.star {
    display: block;
    line-height: 1;
    width: 14px;
    height: 14px;
}
.stat_item__stars i.star-full {
    background: url("/img/clarity_star-solid.svg") 50% no-repeat;
}
.stat_item__stars i.star-half {
    background: url("/img/clarity_half-star-solid.svg") 50% no-repeat;
}
.stat_item__stars i.star-empty {
    background: url("/img/clarity_star-solid-empty.svg") 50% no-repeat;
}
.yellow {
    color: #f2c94c;
}
.grey {
    color: #ddd9ea;
}
</style>
